import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { sleep } from '@wix/wix-ui-test-utils/react-helpers';
import { AccordionDataHooks } from './types';

export interface AccordionDriver extends BaseUniDriver {
  toggleItemAt(index: number): Promise<void>;
  isItemExpandedAt(index: number): Promise<boolean>;
  getItemsCount(): Promise<number>;
  getItemTitleAt(index: number): Promise<string>;
  getItemSubtitleAt(index: number): Promise<string>;
  getItemTitleTagAt(index: number): Promise<string>;
}

const findByHookAtIndex = (base: UniDriver, dataHook: string, index: number) =>
  base.$$(`[data-hook=${dataHook}]`).get(index);

const countByHook = (base: UniDriver, dataHook: string) =>
  base.$$(`[data-hook=${dataHook}]`).count();

const ITEM_ANIMATION_TIME = 300;

export const accordionDriverFactory = (base: UniDriver): AccordionDriver => {
  return {
    ...baseUniDriverFactory(base),
    toggleItemAt: async (index) => {
      await findByHookAtIndex(
        base,
        AccordionDataHooks.AccordionItemHeader,
        index,
      ).click();
      await sleep(ITEM_ANIMATION_TIME);
    },
    isItemExpandedAt: async (index) => {
      const dataStateAttribute = await findByHookAtIndex(
        base,
        AccordionDataHooks.AccordionItemHeader,
        index,
      ).attr('aria-expanded');

      return dataStateAttribute === 'true';
    },
    getItemsCount: () =>
      countByHook(base, AccordionDataHooks.AccordionItemHeader),
    getItemTitleAt: (index) =>
      findByHookAtIndex(base, AccordionDataHooks.AccordionItemHeader, index)
        .$('[data-hook=title]')
        .text(),
    getItemSubtitleAt: (index) =>
      findByHookAtIndex(base, AccordionDataHooks.AccordionItemHeader, index)
        .$('[data-hook=subtitle]')
        .text(),
    getItemTitleTagAt: async (index) =>
      (
        await findByHookAtIndex(
          base,
          AccordionDataHooks.AccordionItemHeader,
          index,
        )
          .$('[data-hook=title]')
          .getNative()
      ).tagName.toLowerCase(),
  };
};
